import { create } from '@/store/module/competition/action/create.js';
import { createDocument } from '@/store/module/competition/action/createDocument.js';
import { createFees } from '@/store/module/competition/action/createFees.js';
import { createProduct } from '@/store/module/competition/action/createProduct.js';
import { deleteDocument } from '@/store/module/competition/action/deleteDocument.js';
import { edit } from '@/store/module/competition/action/edit.js';
import { getByClubId } from '@/store/module/competition/action/getByClubId.js';
import { getById } from '@/store/module/competition/action/getById.js';
import { getDocuments } from '@/store/module/competition/action/getDocuments.js';
import { getEventTypes } from '@/store/module/competition/action/getEventTypes.js';
import { getProducts } from '@/store/module/competition/action/getProducts.js';

export const actions = {
	create,
	createDocument,
	createFees,
	createProduct,
	deleteDocument,
	edit,
	getByClubId,
	getById,
	getDocuments,
	getEventTypes,
	getProducts
};
